var _defs, _path, _path2, _line, _rect, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuantessenceLogoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 290.08,
    height: 25.9,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 290.08 25.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #ed1c25;\r\n      }\r\n\r\n      .st1 {\r\n        stroke-width: 4px;\r\n      }\r\n\r\n      .st1, .st2, .st3 {\r\n        fill: none;\r\n        stroke: #ed1c25;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .st2 {\r\n        stroke-width: 4.6px;\r\n      }\r\n\r\n      .st3 {\r\n        stroke-width: 4.79px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.17,14.08c0,9.05-9.12,8.07-10.3,8.07h-1.05c-1.18,0-10.3,1.05-10.3-8.07V1.42h4.66v12.66c0,3.48,3.35,3.35,3.35,3.35h5.58s3.35.13,3.35-3.35V1.42h4.66v12.66h.07ZM96.85,22.02h-4.66v-12.66c0-3.48-3.35-3.35-3.35-3.35h-6.95v16.01h-4.66V1.36h9.32c1.18,0,10.3-1.05,10.3,8.07v12.6h0ZM119.48,5.95h-7.54v16.07h-4.66V5.95h-7.48V1.29h19.61v4.66h.07ZM142.96,6.47h-12.66c-2.56,0-3.21,1.84-3.35,2.82h11.74v4.66h-11.81s-.13,3.35,3.35,3.35h12.66v4.66h-12.66c-8.66,0-8.13-8.33-8.07-10.1-.07-1.77-.66-10.1,8.07-10.1h12.66v4.72h.07ZM168.35,13.95c0,8.86-9.12,8.07-10.23,8.07h-11.48v-4.72h13.71s3.35.13,3.35-3.35h-17.06v-4.66c0-8.86,9.12-8.07,10.23-8.07h7.22v4.72h-9.45s-3.35-.13-3.35,3.35h17.06v4.66ZM193.67,13.95c0,8.86-9.12,8.07-10.23,8.07h-11.48v-4.72h13.71s3.35.13,3.35-3.35h-17.06v-4.66c0-8.86,9.12-8.07,10.23-8.07h7.22v4.72h-9.45s-3.35-.13-3.35,3.35h17.06v4.66ZM218.27,6.47h-12.66c-2.56,0-3.21,1.84-3.35,2.82h11.74v4.66h-11.81s-.13,3.35,3.35,3.35h12.66v4.66h-12.66c-8.66,0-8.13-8.33-8.07-10.1-.07-1.77-.66-10.1,8.07-10.1h12.66v4.72h.07ZM241.17,22.02h-4.66v-12.66c0-3.48-3.35-3.35-3.35-3.35h-6.95v16.01h-4.66V1.36h9.32c1.18,0,10.3-1.05,10.3,8.07v12.6ZM265.83,6.47h-12.66c-2.56,0-3.21,1.84-3.35,2.82l-.07,4.66h0s-.13,3.35,3.35,3.35h12.66v4.66h-12.66c-8.66,0-8.13-8.33-8.07-10.1-.07-1.77-.66-10.1,8.07-10.1h12.66v4.72h.07ZM289.65,6.47h-12.66c-2.56,0-3.21,1.84-3.35,2.82h11.74v4.66h-11.81s-.13,3.35,3.35,3.35h12.66v4.66h-12.66c-8.66,0-8.13-8.33-8.07-10.1-.07-1.77-.66-10.1,8.07-10.1h12.66v4.72h.07Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.58,21.95v-13.62c0-2.62,2.54-4.75,5.66-4.75h10.24s0,18.36,0,18.36"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 56,
    y1: 16.95,
    x2: 70.85,
    y2: 16.95
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 4.77,
    y: 2.88,
    width: 16.44,
    height: 17.16,
    rx: 5.02,
    ry: 5.02
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 12.98,
    y1: 12.77,
    x2: 21.43,
    y2: 23.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantessenceLogoRed);
export default __webpack_public_path__ + "static/media/Quantessence Logo Red.f52f3c9ca98689fa880d2464119c39e7.svg";
export { ForwardRef as ReactComponent };